<owl-date-time-inline class="wiki__events"
                      (input)="goEvent($event)"
                      [pickerType]="'calendar'">
</owl-date-time-inline>
